const columnRssDetail = {
  namespaced: true,
  state: {
    metadata: {
      'mod': 'nis-subscribe'
    }
  },
  getters: {},
  mutations: {
  },
  actions: {}
}

export default columnRssDetail
